import { Column } from '../layout'
import { TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledColumn = styled(Column)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: var(--tds-spacing-layout-32);
  padding-top: 0;
`

export const StyledButton = styled(TdsButton)`
  margin-top: var(--tds-spacing-layout-48);
`
